export default "__VITE_ASSET__2pBwEe42__"